import React from 'react';
import { Box, Typography } from '@mui/material';

function NoResultsMessage({ searchQuery, filteredResults, initialSearchInitiated }) {
    const wrapperSx = {
        mt: 2,
        width: '100%',
        minHeight: '45vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',     // horizontal zentriert
        justifyContent: 'center', // vertikal zentriert
        textAlign: 'center',
        backgroundColor: 'transparent', // weiß auf weiß
    };

    const imgSx = {
        width: 300,        // kleiner als vorher
        maxWidth: '85%',   // responsive
        height: 'auto',
        display: 'block',
    };

    // 1) Noch keine Eingabe
    if (!searchQuery) {
        return (
            <Box sx={wrapperSx}>
                <Typography sx={{ fontFamily: 'Inter', mb: 2 }}>
                    Start searching...
                </Typography>
                <Box
                    component="img"
                    src="img/cat_searching.gif"
                    alt="Start Searching..."
                    sx={imgSx}
                />
            </Box>
        );
    }

    // 2) Eingabe vorhanden, aber noch nicht gesucht
    if (!initialSearchInitiated) {
        return (
            <Box sx={wrapperSx}>
                <Typography sx={{ fontFamily: 'Inter', mb: 2 }}>
                    Press enter or the Search Button......
                </Typography>
                <Box
                    component="img"
                    src="img/cat_searching.gif"
                    alt="Press enter or the Search Button..."
                    sx={imgSx}
                />
            </Box>
        );
    }

    // 3) Gesucht, aber keine Treffer
    if (filteredResults.length === 0) {
        return (
            <Box sx={wrapperSx}>
                <Typography sx={{ fontFamily: 'Inter', mb: 2 }}>
                    No Results found...
                </Typography>
                <Box
                    component="img"
                    src="img/angry_face.gif"
                    alt="No results for this query..."
                    sx={imgSx}
                />
            </Box>
        );
    }

    return null;
}

export default NoResultsMessage;
